import React, { FC, useContext } from 'react';
import { Box } from '@src/atoms/Box';
import { Icon } from '@src/atoms/Icon';
import { Text } from '@src/atoms/Text';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { DialogContext } from '../context';
import styled from './DialogHeader.module.scss';
import { DATA_ELEM_CLOSE_BTN, DATA_ELEM_HEADER } from '../const';

interface IProps extends IDefaultComponentProps {
  content?: string;
}

export const DialogHeader: FC<IProps> = ({ children, content, className, style }) => {
  const { isMobile, disableCloseBtn, onClose } = useContext(DialogContext);

  const classes = classnames(styled.root, className);
  const closeBtnClasses = classnames(styled.closeBtn, {
    [styled.closeBtnMobile]: isMobile,
  });

  return (
    <Box
      className={classes}
      style={style}
      justifyContent="spaceBetween"
      alignItems="center"
      marginBottom={8}
      data-elem={DATA_ELEM_HEADER}
    >
      {content && (
        <Text id="header" size="h3">
          {content}
        </Text>
      )}
      {children}
      {!disableCloseBtn && (
        <div className={closeBtnClasses} onClick={onClose} data-elem={DATA_ELEM_CLOSE_BTN}>
          <Icon name="close" />
        </div>
      )}
    </Box>
  );
};
